import React from 'react';
import store from '../store';
import { slugify,YesNoList,s2ab,insert_rows} from '../config/static';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle  from '@material-ui/core/DialogTitle';
import ReactPlayer from "react-player";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import LocationOnIcon from '@material-ui/icons//LocationOn';
import EditIcon from '@material-ui/icons//Edit';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import Typography from '@material-ui/core/Typography';
import firebase from "firebase/app";
import "firebase/firestore";
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import ImageIcon from '@material-ui/icons/Image';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import Dropzone from "react-dropzone";
import { NotificationManager} from 'react-notifications';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import * as STATIC from '../config/static';
import * as LHELPER from './LessonHelper';
import _ from 'lodash';
import { CSVLink, CSVDownload } from "react-csv";
import XLSX from 'xlsx';
import moment from 'moment';
var FileSaver = require('file-saver');
// const csvData = [
//   ["firstname", "lastname", "email"],
//   ["Ahmed", "Tomi", "ah@smthing.co.com"],
//   ["Raed", "Labes", "rl@smthing.co.com"],
//   ["Yezzi", "Min l3b", "ymin@cocococo.com"]
// ];
function generateSearch(item){
  let arr = slugify(item.ten).split('-');
  arr.push(slugify(item.ten).replace(/\-/gi, " "));
  arr.push(item.id.toLowerCase());
  return arr;
}

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '90%'
  },search: {
      backgroundColor: '#fff',
      padding: theme.spacing.unit,
      paddingLeft: theme.spacing.unit * 2,
      borderRight: 'solid 1px #ededed',
      borderLeft: 'solid 1px #ededed',
      borderTop: 'solid 1px #ededed'
  },
  textField: {
    minWidth: 200
  },
  input: {
    display: 'none',
  },group_list:{
    border:"1px solid gray",
    display:'flex',
    flexDirection:'column'
  },
  group_list_item:{
    textAlign:'center',
    border:"1px solid gray",
    padding:5,
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    wordBreak:'break-word'
  }
  ,
  group_list_input:{
    textAlign:'center',
    border:"none",
    background:'transparent',
    width: '100%',
    height: '100%',
  },
});
function searchLabel(array,value)
{
  let rel='';
  let index = array.findIndex(a=>a.value==value);
  if(index>-1)
  {
    rel = array[index].label;
  }
  return rel;
}
var _this;


class CreateDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: _.cloneDeep(props.item),

      open: false,
      curSetIndex:0,
      curWeek:null,
      curDay:null,
      curDayIndex:null,
      csvData:[],
      downloadCSV:false,
      results:[],
      curLevelIndex:0,
      curRoundIndex:0,
      limit:100,
      agentIndex:"All",
      agents:[],
    }
    _this = this;
  }
  componentDidMount(props)
  {
    this.loadAgents();
  }
  async loadAgents()
  {
    let agents = [];
      let data = await firebase.firestore().collection("data_agents").where("enable","==",1).get();

      if(data.size>0)
      {
        data.forEach(d=>{
          let i = d.data();
          agents.push(i);
        })
      }
      _this.setState({agents});
  }

export(item)
{
  if(item.type.length==0)
  return;
  let questions =  LHELPER.randomQuestionList(item.qCount,item);
//  console.log(questions);
  let headers = [];
  let headers2 = [];
  let csvData = [];
  let data = [];
  let results = [];
  let spaces = [];
  for(let n=0;n<item.rows;n++){
    data[n]=[];
  }
  for(let r=0;r<item.qCount;r++)
  {
    headers.push('C'+(r+1));
    let q = questions[r];
    for(let n=0;n<item.rows;n++){
      data[n].push(q.numbers[n]);
    }
    results.push(q.result);
    spaces.push("");
    headers2.push(q.type);
  }
csvData.push(headers);
  csvData.push(headers2);
  for(let n=0;n<item.rows;n++){
    csvData.push(data[n]);
  }
  csvData.push(spaces);
  csvData.push(results);
  _this.setState({csvData,downloadCSV:true});
}
showDownload(csvData){
  setTimeout(()=>{
    _this.setState({downloadCSV:false});
  },2000)
  return <CSVDownload data={csvData} target="_blank" />;
}



  handleChange = name => event => {
    event.preventDefault();
    const item = _this.state.item;

    item[name] = event.target.value;

    _this.setState({ item });
  }

  handleDelete = (name,value) => {
    const { item,curDayIndex,curWeekIndex } = this.state;
    let curDay =  item;
      let change = curDay[name];

      change = _.without(change,value);
      curDay[name] = change;

      this.setState({
          item
      });
  }




  DeleteItem = (id) => event => {
    var check = window.confirm("Do you want to delete this category?");
    var _this=this;
    if (check === true) {
        firebase.firestore().collection("categories").doc(id).delete().then(()=>{
            NotificationManager.success("Success!");
            _this.props.onClose();
        });
    }

  }
  handleClose = () => event => {
    event.preventDefault();
    //this.setState(RESET_CITY);
    this.props.onClose();
  };
  handleChangeWeek = event=>{
    event.preventDefault();

    this.setState({curWeekIndex:event.target.value,curDayIndex:null})
  }


checkMultiOrDivide(type){

  for(let t of type)
  {
    if(t=="multiple"||t=='divide')
    return true;
  }
  return false;
}
checkDivide(type){

  for(let t of type)
  {
    if(t=='divide')
    return true;
  }
  return false;
}
onItemChange = (value,item,key)=>{
  item[key]=value;
  if(key=="active")
  {
    //console.log('Update')
    firebase.firestore().collection('competitors').doc(item.id).update({active:value});
  }
  this.forceUpdate();
}
async findItems(){
  const { search,item } = this.state;
  if(!search||search.trim().length<2)
  {
      return NotificationManager.error("Hãy nhập ít nhất 2 ký tự!");
  }
  let arr = slugify(search).split('-');
  let data = await firebase.firestore().collection("competitors").where("comp_id","==",item.comp_id).where("search","array-contains-any",arr).get();
  let results = [];
  if(data.size>0)
  {
    data.forEach((doc)=>{
      let i = doc.data();
      i.id = doc.id;
      results.push(i);
    })
  }
  //console.log(results);
    _this.setState( {results});
}
async loadResults(){
  const { curLevelIndex,curRoundIndex,item,limit,agentIndex } = this.state;


  if(!limit||parseInt(limit)<1||parseInt(limit)>5000)
  {
      return NotificationManager.error("Hãy nhập giới hạn từ 1-5000");
  }
  let nlimit = parseInt(limit);
  //console.log(nlimit,item.id,"Level_"+curLevelIndex+"_Round_"+curRoundIndex);
  let docRef = firebase.firestore().collection("comps").doc(item.id).collection("Level_"+curLevelIndex+"_Round_"+curRoundIndex);

  let data = await docRef.orderBy("total_point","desc").limit(nlimit).get();
  let results = [];
  //console.log(data.size);
  if(data.size>0)
  {
    data.forEach((doc)=>{
      let i = doc.data();
      i.id = doc.id;
      results.push(i);
    })
  }
  //console.log(results);
    _this.setState( {results});
}

async removeResult(comp,index) {
  const { curLevelIndex,curRoundIndex,item,limit } = this.state;
  var check = window.confirm("Bạn có muốn xoá kết qủa vòng "+(curRoundIndex+1)+" cuả thí sinh "+comp.ten+"?");
  if(check)
  {
    const { curLevelIndex,curRoundIndex,item,limit } = this.state;
    let data = await firebase.firestore().collection("comps").doc(item.id).collection("Level_"+curLevelIndex+"_Round_"+curRoundIndex).doc(comp.username).collection("results").get();
    if(data.size>0)
    {
      //console.log(data.size)
      data.forEach(d=>d.ref.delete());
    }
    //await firebase.firestore().recursiveDelete(firebase.firestore().collection("comps").doc(item.id).collection("Level_"+curLevelIndex+"_Round_"+curRoundIndex).doc(comp.username).collection("results"));
    firebase.firestore().collection("comps").doc(item.id).collection("Level_"+curLevelIndex+"_Round_"+curRoundIndex).doc(comp.username).delete();
    _this.state.results.splice(index,1)
    _this.forceUpdate();
  }
}
async clearAll() {
  const { curLevelIndex,curRoundIndex,item,limit } = this.state;
  var check = window.confirm("Bạn có muốn xoá tất cả kết quả của vòng "+(curRoundIndex+1)+" ?");
  if(check)
  {

    let docRef = firebase.firestore().collection("comps").doc(item.id).collection("Level_"+curLevelIndex+"_Round_"+curRoundIndex);

    let data = await docRef.get();
    let results = [];
    if(data.size>0)
    {
      data.forEach((doc)=>{
        let i = doc.data();
        i.id = doc.id;
        results.push(i);
      })
    }
    let batch = firebase.firestore().batch();
  				let count = 0;
  				for(let i of results)
  				{
  					const ref = firebase.firestore().collection("comps").doc(item.id).collection("Level_"+curLevelIndex+"_Round_"+curRoundIndex).doc(i.id);
            let data2 = await firebase.firestore().collection("comps").doc(item.id).collection("Level_"+curLevelIndex+"_Round_"+curRoundIndex).doc(i.id).collection("results").get();
            if(data2.size>0)
            {
              //console.log(data.size)
              data2.forEach(d=>  {
                batch.delete(d.ref);
                count++;
              });
            }
            batch.delete(ref);
  					count++;
  					if(count>400)
  					{
  						await batch.commit();
  						batch = firebase.firestore().batch();
  						count=0;
  					}
  				}
          await batch.commit();
          _this.setState({results:[]})
  }
}
async importData(data)
{
  let batch = firebase.firestore().batch();
				let count = 0;
				for(let i of data)
				{
					const ref = firebase.firestore().collection('competitors').doc(i.id);
          let search = generateSearch(i);
          batch.set(ref, {...i,search,updated:(new Date().getTime())}, { merge: true });
					count++;
					if(count>400)
					{
						await batch.commit();
						batch = firebase.firestore().batch();
						count=0;
					}
				}
        await batch.commit();
        NotificationManager.success("Đã thêm "+data.length);
}
async exportExcel() {
  var wb = XLSX.utils.book_new();
  wb.Props = {Title: "Danh sách thí sinh"};
        // wb.SheetNames.push("Sheet 1");
        // const ws = wb.Sheets["Sheet 1"];
        let data = _this.state.results;
        let row = 2;
        let count = 1;
        let ws_data = [["Tên đăng nhập","Tên","Ngày Sinh","Cơ sở","SĐT","Email","Mã cuộc thi","Cấp độ","Tổng điểm"]]

        for(let i of data)
        {



          // ws['A'+row].v = count;
          // ws['B'+row].v = d.created_name;
          // ws['E'+row].v = moment(d.created_date).format("DD/MM/YYYY");
          // ws['F'+row].v = d.project;
          // ws['G'+row].v = code;
          // ws['H'+row].v = name;
          // ws["H4"].v = SL;
          // ws['J'+row].v = SL_Complete;
          ws_data.push([i.username,i.ten,moment(i.ngay_sinh).format("DD/MM/YYYY"),i.ten_cs,i.sdt,i.email,i.comp_id,i.level+1,i.total_point]);
    }
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    var contents = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
    var blob = new Blob([s2ab(contents)], {type: "application/octet-stream"});
    FileSaver.saveAs(blob, "KQ_TS_"+moment().format('YYYYMMDDHHmmss')+".xlsx");
}
  render() {
    const { classes, onClose, fullScreen, onChange, ...other } = this.props;
    const { item,csvData,downloadCSV,results,curLevelIndex,curRoundIndex,agentIndex,agents } = this.state;
    const agentList = [];
    for(let i of agents)
    {
      let a = {label:i.ten,value:i.machinhanh};
      agentList.push(a);
    }
let width=500;

    return (<div>
      {downloadCSV?this.showDownload(csvData):false}
      {!item ? '' :
        <Dialog onClose={this.props.onClose} open={false} fullScreen={fullScreen} {...other}>
          <DialogTitle>
            <Grid justify="flex-start" direction="row" container>
              <Grid item style={{ marginRight: 8 }}><AllInboxIcon /></Grid>
              <Grid item>
                <Typography variant="title" className={classes.title}></Typography>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.container}>
            <Typography variant="title" color="primary" style={{ marginBottom: 10 }}>Kết quả của {item.name}</Typography>

              <Divider style={{marginTop:10,marginBottom:10}} />

            <Grid container style={{marginTop:20}}>

              {item.levels.map((i, index) => {
                let current = curLevelIndex!=null?index==curLevelIndex:false;
                //console.log(current,i,curRoundIndex);
                let haveData = item.levels[curLevelIndex]?true:false;
                return (<Grid  key={index} item style={{width:100,height:100,marginLeft:10,marginBottom:10}} >
                  <Button onClick={e=>this.setState({curLevelIndex:index},()=>this.loadResults())} style={{width:100,height:100,backgroundColor:current?'#1B5E20':'grey',color:'white'}} size="large">
                    {i.name}
                </Button>
              </Grid>)})}
            </Grid>
            <Grid container xs={12} style={{marginTop:20}}>

              {item.levels[curLevelIndex].rounds.map((i, index) => {
                let current = curRoundIndex!=null?index==curRoundIndex:false;
                //console.log(current,i,curRoundIndex);
                let haveData = item.levels[curLevelIndex].rounds[curRoundIndex]?true:false;
                return (<Grid  key={index} item style={{width:100,height:100,marginLeft:10,marginBottom:10}} >
                  <Button onClick={e=>this.setState({curRoundIndex:index},()=>this.loadResults())} style={{width:100,height:100,backgroundColor:current?'#1B5E20':'grey',color:'white'}} size="large">
                    Vòng {i.name||(index+1)}
                </Button>
              </Grid>)})}
            </Grid>
            <Grid>
            <Divider style={{marginTop:10,marginBottom:10}} />
              <FormControl style={{ marginBottom: 30 }} fullWidth>
                  Top <Input
                      value={this.state.limit}
                      onChange={(e)=>this.setState({limit:e.target.value})}
                      type="text"
                      placeholder="Giới hạn"
                      className={classes.search}
                      style={{width:100}}
                  />
              </FormControl>
            </Grid>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                      value={_this.state.agentIndex}
                      onChange={(e)=>this.setState({agentIndex:e.target.value})}
                      label="Cơ sở"
                      placeholder=""
                      select
                      margin="normal"
                      InputLabelProps={{
                          shrink: true,
                          style: { color: '#1B5E20',fontSize:'1.2rem' }
                      }}
                      style={{width:width*0.3,marginLeft:10}}>
                      <MenuItem value={"All"}>
                        Tất cả
                      </MenuItem>
                      {agentList.map((t,index)=>{
                        return (<MenuItem key={"AgentItem"+index} value={t.value}>
                      {t.label}
                    </MenuItem>)
                      })}
                    </TextField>
                </Grid>
                </Grid>
            <Button onClick={()=>this.loadResults()} variant="contained" color="secondary" size="medium">
                    Xem danh sách
                </Button>
                <Divider style={{marginTop:10,marginBottom:10}} />
            <Grid container>
              <Grid item xs={12}>
                {results&&results.length>0&&<div>
                  Tổng: {results.length} <Button onClick={()=>this.exportExcel()} variant="contained" color="secondary" size="medium">
                          Export Excel
                      </Button>
                      <Button style={{marginLeft:10}} onClick={()=>this.clearAll()} variant="contained" color="secondary" size="medium">
                              Xoá tất cả kết quả vòng này
                          </Button>
              </div>}
            </Grid>
              <Grid item xs={12}>
                {results&&results.length>0&&<div className={classes.group_list}>
                      <div style={{display:'flex',flexDirection:'row'}}>
                      <div className={classes.group_list_item} style={{width:'5%'}}>TT</div>
                        <div className={classes.group_list_item} style={{width:'15%'}}>Tên đăng nhập</div>
                        <div className={classes.group_list_item} style={{width:'15%'}}>Tên</div>
                        <div className={classes.group_list_item} style={{width:'10%'}}>Cơ sở</div>
                        <div className={classes.group_list_item} style={{width:'10%'}}>Ngày sinh</div>
                        <div className={classes.group_list_item} style={{width:'8%'}}>SĐT</div>
                        <div className={classes.group_list_item} style={{width:'15%'}}>Email</div>
                        <div className={classes.group_list_item} style={{width:'15%'}}>Tổng Điểm</div>
                        <div className={classes.group_list_item} style={{width:'7%'}}></div>
                    </div>
                    {results.filter(r=>r.ma_cs==agentIndex||agentIndex=="All").map((r,index)=>{

                      return <div key={index} style={{display:'flex',flexDirection:'row'}}>
                      <div className={classes.group_list_item} style={{width:'5%'}}>{index+1}</div>
                        <div className={classes.group_list_item} style={{width:'15%'}}>{r.username}</div>
                          <div className={classes.group_list_item} style={{width:'15%'}}>{r.ten}</div>
                          <div className={classes.group_list_item} style={{width:'10%'}}>{r.ten_cs}</div>

                          <div className={classes.group_list_item} style={{width:'10%'}}>{moment(r.ngay_sinh).format("DD/MM/YYYY")}</div>
                          <div className={classes.group_list_item} style={{width:'8%'}}>{r.sdt}</div>
                          <div className={classes.group_list_item} style={{width:'15%'}}>{r.email}</div>
                          <div className={classes.group_list_item} style={{width:'15%'}}>{r.total_point}</div>
                          <div className={classes.group_list_item} style={{width:'7%'}}><Button onClick={()=>this.removeResult(r)} variant="contained" color="error" aria-label="add" size="small">Xoá
                    </Button></div>
                  </div>
                    })}

                  </div>}
              </Grid>
            </Grid>






          </DialogContent>

          <DialogActions style={{ padding: 10 }}>
            <Button onClick={this.handleClose()} size="large">
              <CloseIcon style={{ marginRight: 5 }} />BACK
          </Button>
          {/*!item.id ? '' : <Button onClick={this.DeleteItem(item.id)} size="large" color="primary">
              <DeleteIcon style={{ marginRight: 5 }} /> DELETE </Button>*/}

              {false&&<Button onClick={()=>this.export(item)}  size="large" variant="contained" color="secondary">
                Export
        </Button>}
          </DialogActions>
        </Dialog>
      }</div>);
  }
}

CreateDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func
};

export default withStyles(styles)(CreateDialog);
